import { isAuthenticatedUser } from 'js/lib/user';

import useAdminPermissions from 'bundles/admin-shared/hooks/useAdminPermissions';

const useAdminHeaderPermissions = () => {
  const { loading, permissions } = useAdminPermissions();
  const isAuthenticated = isAuthenticatedUser();

  return {
    adminPermissions: isAuthenticated ? permissions : undefined,
    adminPermissionDataLoading: isAuthenticated ? loading : false,
  };
};

export default useAdminHeaderPermissions;
